import React from "react";

import styles from "./header-logo.module.css";

const HeaderLogo = () => {
  const logo = process.env.REACT_APP_LOGO_PATH;
  return (
    <div className={styles.container}>
      <img className={styles.logo} src={logo} alt="" />
    </div>
  );
};

export default HeaderLogo;
